import { DEAL_PRIVILEGE, TABS } from '@constants/common.constants';
import { IDeal } from '@interfaces/deal';
import { IPrivilege } from '@interfaces/privilege';
import Listing from './Listing';

interface SectionConfig {
	tabType: TABS;
	tabName: string;
	description: string;
	data: IDeal[] | IPrivilege[];
	isLoading: boolean;
	type: DEAL_PRIVILEGE;
}

interface DealPrivilegeTabContentProps {
	selectedTab: TABS;
	sectionConfig: SectionConfig[];
}

export default function DealPrivilegeTabContent({ selectedTab, sectionConfig }: DealPrivilegeTabContentProps) {
	const renderSection = (section: SectionConfig) => {
		const { tabType, tabName, description, data, isLoading, type } = section;
		if (selectedTab !== TABS.ALL && selectedTab !== tabType) {
			return null;
		}

		return (
			<section className='w-full min-w-0' data-testid={`section-${tabType.toLowerCase()}`} key={tabType}>
				<header>
					<h2 className='font-semibold text-2xl ml-6 tablet:ml-0'>{tabName}</h2>
					<p className='px-6 mb-4 tablet:px-0 text-sm tablet:text-base max-w-full'>{description}</p>
				</header>
				<div className='w-full min-w-0'>
					<Listing data={data} isLoading={isLoading} selectedTab={selectedTab} type={type} />
				</div>
			</section>
		);
	};

	return (
		<main className='w-full bg-[#f5f5f5] tablet:px-6 desktop:px-4 pt-4 pb-[60px] rounded-lg flex flex-col gap-6 tablet:gap-8 desktop:gap-14'>
			{sectionConfig.map(renderSection)}
		</main>
	);
}
